/**
 * Toast notification mixin for admin views. Provides notifyMe(message, variant)
 * so each view doesn't carry its own copy of the $bvToast boilerplate.
 */
export default {
  methods: {
    notifyMe(message, variant = 'danger') {
      this.$bvToast.toast(message, {
        title: 'Notification',
        solid: true,
        variant: variant,
        autoHideDelay: 2500,
        appendToast: true
      })
    }
  }
}
